import React from 'react';
import Section from '@latitude/section-rebrand';
import { Box } from '@latitude/box';
import styled from 'styled-components';
import { COLOR, REBRAND_COLOR, BREAKPOINT } from '@latitude/core/utils/constants';

const StyledFlex = styled.div`
  display:flex;
  gap:24px;
  align-items:center;

  svg {
   width: 50px;
   height: 50px;
   flex-shrink: 0;
   @media (max-width: ${BREAKPOINT.MD}) {
      width: 30px;
      height: 30px;
   }
  }
`;

const StyledText = styled.div`
  a, a:hover {
    border-bottom: solid 1px ${REBRAND_COLOR.INDIGO};
  }  
`;

export const Banner = ({ children, onClose, showClose }) => {
  return (
    <Box
      backgroundColor={COLOR.WHITE}
      padding="20px 0"
      css="position:relative; z-index:3;"
    >
      <Section>
        <StyledFlex>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
        >
          <path
            d="M57.9837 32C57.9837 37.1387 56.4603 42.163 53.6046 46.4356C50.7499 50.7091 46.6912 54.0393 41.944 56.0054C37.196 57.9724 31.9715 58.4868 26.9306 57.4847C21.8907 56.4818 17.2604 54.0072 13.627 50.373C9.99279 46.7396 7.51828 42.1093 6.51529 37.0694C5.51321 32.0285 6.02769 26.8041 7.99465 22.056C9.96076 17.3088 13.291 13.2501 17.5644 10.3954C21.837 7.53981 26.8614 6.0163 32.0001 6.0163C38.8918 6.0163 45.5003 8.75412 50.3731 13.6269C55.2459 18.4997 57.9837 25.1091 57.9837 32Z"
            fill="#FDB022"
          />
          <circle cx="31.9995" cy="44.0864" r="3.12765" fill="#0B2374" />
          <path
            d="M32 14.8751L32 36.2479"
            stroke="#0B2374"
            stroke-width="3.90751"
            stroke-linejoin="round"
          />
        </svg>
        <StyledText>{children}</StyledText>
        {showClose && (
          <button
            type="button"
            className="banner-button-close"
            css={`
              color: ${REBRAND_COLOR.INDIGO};
              font-size: 30px;
              margin: 0;
              padding: 0 5px;
            `}
            aria-label="Close"
            onClick={onClose}
          >
            <div aria-hidden="true">&times;</div>
          </button>
        )}
        </StyledFlex>
      </Section>
    </Box>
  );
};
